import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { createFileRoute } from '@frontend/web/utils/router';
import { lazy, Suspense } from 'react';

const LazyMCPSignup = lazy(() => import('./-mcp').then((module) => ({ default: module.MCPSignup })));

const MCPSignupRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyMCPSignup />
  </Suspense>
);

export const Route = createFileRoute('/signup/mcp')({
  component: MCPSignupRouteComponent,
});
